/**
 * used for the more toggle text on the project description
 */
export default (() => {
  const LIMIT_LINES = 4;
  const DESCRIPTION_HIDDEN = "description--hidden";

  const init = () => {
    const descriptionWrapper = document.querySelector(".js-description");

    if (descriptionWrapper === null) {
      return;
    }

    const description = descriptionWrapper.querySelector(".description");

    if (description === null) {
      return;
    }

    const lines = _countLines(description);

    if (lines > LIMIT_LINES + 1) {
      description.classList.add(DESCRIPTION_HIDDEN);
      _createMoreToggle(descriptionWrapper, description);
    }
  }

  /**
   * count text lines inside element
   *
   * @param {HTMLElement} el
   * @return {number}
   * @private
   * @link https://stackoverflow.com/a/37623987/4375061
   */
  const _countLines = (el) => {
    const style = window.getComputedStyle(el, null);
    const elHeight = parseInt(style.getPropertyValue("height"));
    const lineHeight = parseInt(style.getPropertyValue("line-height"));
    const lines = elHeight / lineHeight;
    return lines;
  }

  const _createMoreToggle = (el, description) => {
    const moreToggle = document.createElement("button");
    moreToggle.type = "button";
    moreToggle.classList.add("link");
    moreToggle.classList.add("js-more-toggle");
    moreToggle.textContent = "mehr";

    moreToggle.addEventListener("click", () => {
      description.classList.remove(DESCRIPTION_HIDDEN);
      moreToggle.remove();
    }, {once: true});
    el.append(moreToggle);
  }

  return {
    init
  }
})()
